<template>
  <main>
    <error-notification />
    <header role="banner" class="container-banner">
      <img class="logo" src="~@imagesBrand/logo.svg">
      <router-link to="/signin">Sign In</router-link>
    </header>
    <section class="container-small">
      <vue-form :state="formstate" class="form notranslate" @submit.prevent="signup">
        <h3 v-t>CI Direct Investing for Advisors</h3>
        <h4 v-t>Create Account</h4>

        <validate class="field">
          <label v-t for="email">Email</label>
          <input id="email" v-model="model.email" type="text" name="email" required>
          <field-messages name="email" class="error-message">
            <template slot="required">
              <small v-if="formstate.$touched || formstate.$submitted" v-t class="error">Required</small>
            </template>
          </field-messages>
        </validate>

        <validate class="field">
          <label v-t for="password">Password</label>
          <input-password v-model="model.password" class="input" name="password" required />
          <field-messages name="password" class="error-message">
            <template slot="required">
              <small v-if="formstate.$touched || formstate.$submitted" v-t class="error">Required</small>
            </template>
          </field-messages>
        </validate>

        <p v-if="showAdvisorServiceAgreementLink">
          <span v-t>By signing up, you agree to</span>
          &nbsp;
          <a v-t :href="advisorServiceAgreementUrl" target="_blank">CI Direct Investing's Advisor Service Agreement</a>
          &nbsp;<span v-t>and our</span> <a v-t href="/privacy" target="_blank">Privacy Policy</a>.
        </p>
        <button v-if="!loading" v-t type="submit" class="full">Create Account</button>
        <div v-else class="loader">
          <loading-spinner size="1rem" />
          <span v-t>Creating Account…</span>
        </div>
        <div v-if="errorMessage" class="error-message">
          <p>
            <span>{{ errorMessage }} </span>
            <span v-t>Please </span>
            &nbsp;
            <button v-t class="neg" @click="showIntercom()">contact us</button>
            &nbsp;
            <span v-t> if you require assistance.</span>
          </p>
        </div>
      </vue-form>
    </section>
  </main>
</template>

<script>
import { http } from '@/lib/api/rest';
import { auth0Signup } from '@/lib/auth';
import { intercom } from '@/lib/analytics';
import getBrandConfig from '@/lib/utils/get_brand_config';
import { inputPassword, loadingSpinner, errorNotification } from '@/components/layout';
import errorStore from '@/store/error';

const brandConfig = getBrandConfig();
const _ = {
  auth: brandConfig.auth,
  auth0Signup,
  intercom,
  errorStore,
  http,
};

export default {
  _,
  name: 'Signup',
  components: { inputPassword, loadingSpinner, errorNotification },

  data() {
    return {
      formstate: {},
      errorMessage: '',
      loading: false,
      model: {
        email: '',
        password: '',
        partner_channel: brandConfig.brand,
        language: '',
      },
      showAdvisorServiceAgreementLink:
        brandConfig.advisorServiceAgreementLink,
      advisorServiceAgreementUrl: brandConfig.advisorServiceAgreementUrl,
    };
  },

  async beforeRouteEnter(to, from, next) {
    if (_.auth === 'auth0') {
      _.auth0Signup();
    } else { next(); }
  },

  created() {
    this.model.language = this.$lang.slice(0, 2) === 'fr' ? 'fr_CA' : this.$lang.slice(0, 2);
  },

  methods: {
    async signup() {
      if (this.formstate.$invalid || this.loading) return;
      this.loading = true;
      this.errorMessage = '';
      try {
        await _.http.post('sessions/signup', this.model);
        this.$router.push('/app/clients');
      } catch (exception) {
        this.loading = false;
        if (exception.response && exception.response.status === 403) {
          this.errorMessage = this.$t('Advisor already exists.');
        } else if (exception.response && exception.response.status === 400) {
          this.errorMessage = this.$t('Invalid e-mail or password.');
        } else {
          _.errorStore.addError();
        }
      }
    },
    showIntercom() {
      _.intercom('show');
    },
  },
};
</script>
<style lang="scss" scoped>
  main {
    display: flex;
    flex-direction: column;
  }
  header[role="banner"]  {
    background: $white;
    width: 100%;
    z-index: 5;
    border-bottom: 1px solid $pearl-300;
    height: 3.25rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1.5rem;
    @media #{$screen-width-medium} {
      padding: 0.5rem 3rem;
    }
  }
  .logo {
    height: 2.375rem;
    max-width: 10rem;
  }
  section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1 1 100%;
  }
  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    span { margin-left: 0.25rem; }
  }
</style>
